export const WS_HUB = '/hubs';
